import React, { useState, useEffect } from 'react';
import { apiPost } from '../../api';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';

const UpdateUserPassword = () => {
  const { username } = useParams();
  const [form, setForm] = useState({
    username: ''
  });
  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState('');

  useEffect(() => {
    if (username) {
      setForm(f => ({ ...f, username: username }));
    }
  }, [username]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMessage('');

    try {
      const res = await apiPost('/api/admin/user/reset-password', form);
      if (res.data.success) {
        toast.success('Password reset successful');
        setResponseMessage(res.data.message || 'Password reset successful');
        setForm({ username: '' });
      } else {
        toast.error(res.data.message || 'Failed to reset password');
        setResponseMessage(res.data.message || 'Failed to reset password');
      }
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'Error resetting password';
      toast.error(errorMessage);
      setResponseMessage(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-lg mx-auto">
      <div className="flex items-center gap-3 text-[10px] font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-1">
        <span className="h-px w-6 bg-ginox-green" aria-hidden="true" />
        Management
      </div>
      <h1 className="font-serif italic text-[45px] leading-[1.02] text-foreground mb-1">Reset <span className="text-gradient-ginox">Password</span></h1>
      <p className="text-sm text-muted-foreground mb-6">Trigger a password reset for the specified user account.</p>

      <div className="border-t border-white/[0.08] pt-6">
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-medium uppercase tracking-[0.06em] text-muted-foreground mb-1.5">
              Username
            </label>
            <input
              name="username"
              value={form.username}
              onChange={handleChange}
              placeholder="Username"
              className="w-full rounded-md border border-border/70 bg-white/[0.03] px-3 py-2 text-sm text-foreground font-mono placeholder:text-muted-foreground/50 focus:border-ginox-green/50 focus:outline-none focus:ring-1 focus:ring-ginox-green/30 read-only:opacity-60"
              required
              readOnly
            />
          </div>

          <div className="pt-1">
            <button
              type="submit"
              disabled={loading}
              className="rounded-md border border-ginox-green/60 bg-ginox-green/10 px-4 py-2 text-xs font-medium text-ginox-green hover:bg-ginox-green/20 transition-colors disabled:opacity-50 w-full"
            >
              {loading ? 'Resetting...' : 'Reset Password'}
            </button>
          </div>
        </form>

        {responseMessage && (
          <div className="mt-5 pt-5 border-t border-border/40">
            <p className="text-xs font-medium uppercase tracking-[0.06em] text-muted-foreground mb-1.5">Response</p>
            <p className="text-sm text-foreground">{responseMessage}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UpdateUserPassword;
